import data from "../../.sourceflow/services.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const services_helper = new CollectionHelper(data);
